export default __webpack_public_path__ + "static/media/provider1.5bbde136.svg";